import OperationsSettings from "@/components/OperationsSettings";

// Operations & SLA now lives under Automation (moved out of Settings).
// Reuses the existing OperationsSettings component unchanged (loads/saves via /settings/operations).
export default function OperationsSLA() {
  return (
    <div className="mx-auto max-w-3xl space-y-6" data-testid="operations-sla-page">
      <div>
        <h1 className="font-sora text-3xl font-bold text-navy">Operations &amp; SLA</h1>
        <p className="text-sm text-ink/60">Office hours, working days and the response-SLA clock that drive lead auto-assignment and reshuffling.</p>
      </div>
      <OperationsSettings />
    </div>
  );
}
